/* import __COLOCATED_TEMPLATE__ from './event-rules-editor.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();